import AbstractSettings from "../shared/AbstractSettings";

export default class Settings extends AbstractSettings {
    snapToGridCheckbox;
    accessSelector;
    showImageCheckbox;

    init({ showGrid = true, snapToGrid = true, showLabels = true, showImage = 'true', units = 'metric', access = 'public', name = null, lockLabels = true, autoSave = true } = {}) {
        this.showGrid = showGrid;
        this.snapToGrid = snapToGrid;
        this.showLabels = showLabels;
        this.lockLabels = lockLabels;
        this.showImage = showImage;
        this.units = units;
        this.access = access;
        this.name = name;
        this.autoSave = autoSave;

        this.showGridCheckbox.changed(() => {
            if (this.showGridCheckbox.checked()) {
                this.snapToGrid = true;
                this.snapToGridCheckbox.elt.firstChild.firstChild.disabled = false;
            } else {
                this.snapToGrid = false;
                this.snapToGridCheckbox.elt.firstChild.firstChild.disabled = true;
            }
        });
    }

    get snapToGrid() {
        return this.snapToGridCheckbox.checked() == 1;
    }

    set snapToGrid(snapToGrid) {
        this.snapToGridCheckbox.checked(snapToGrid ? 1 : 0);
    }

    get lockLabels() {
        return this.lockLabelsCheckbox.checked() == 1;
    }

    set lockLabels(lockLabels) {
        this.lockLabelsCheckbox.checked(lockLabels ? 1 : 0);
    }

    get access() {
        return this.accessSelector.value();
    }

    set access(access) {
        this.accessSelector.value(access);
    }

    get name() {
        return this.nameInput.value();
    }

    set name(name) {
        this.nameInput.value(name);
    }

    get autoSave() {
        return this.autoSaveCheckbox.checked() == 1;
    }

    set autoSave(autoSave) {
        this.autoSaveCheckbox.checked(autoSave ? 1 : 0);
        this.changesMade();
    }

    export() {
        return {
            showGrid: this.showGrid,
            snapToGrid: this.snapToGrid,
            showLabels: this.showLabels,
            lockLabels: this.lockLabels,
            showImage: this.showImage,
            units: this.units,
            autoSave: this.autoSave,
        }
    }

    store() {
        if (this.storage) {
            this.storage.save();
        }
    }
}
